import React, { useEffect, useState } from 'react';
import Navbar from '../Navbar';
import { Link, useNavigate } from 'react-router-dom';
import {Box, Button,Grid, Hidden, TextField, Typography} from '@mui/material';
import swal from 'sweetalert';
import axios from 'axios';
// import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from "@mui/icons-material/Edit";
import _ from "lodash";
// import * as swal from 'sweetalert';
import Swal from 'sweetalert2';
import BootstrapTable from 'react-bootstrap-table-next';
import 'bootstrap/dist/css/bootstrap.min.css';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
import DownloadIcon from '@mui/icons-material/Download';
import filterFactory,{textFilter, selectFilter} from 'react-bootstrap-table2-filter';
import overlayFactory from 'react-bootstrap-table2-overlay';
import { removeFilterTitle } from "../../util/removeFilterTitle";
import {
  createTheme,
  PaletteColorOptions,
  ThemeProvider,
} from "@mui/material/styles";
import { Stack } from "@mui/material";

function ShowInvoices() {

  //useState declarations
  const [loading, setLoading] = useState(true);
  const [categorylist, setCategorylist] = useState([]);


  useEffect(()=>{
    removeFilterTitle(".sr-only");
  },[]);

  //colour palette
  const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) =>
    augmentColor({ color: { main: mainColor } });
  const theme = createTheme({
    palette: {
      anger: createColor("#F40B27"),
      apple: createColor("#A38A00"),
      steelBlue: createColor("#5C76B7"),
      violet: createColor("#BC00A3"),
    },
    button: {
      // Here is where you can customise the button
      fontSize: 16,
      fontWeight: 1700,
    },
  });

  const dumpInvoiceData = async (e) => {
    e.preventDefault();
    if(sDate==''){
      swal("Error", 'Please Select Start Date and End Date', "error"); 
    }else{
    
      const currentTimestamp = new Date();
      // const formattedDateTime = new Date(currentTimestamp).toLocaleTimeString().replace(/[-:]/g, '');
      const showTime = currentTimestamp.getHours() 
        + '' + currentTimestamp.getMinutes() 
        + "" + currentTimestamp.getSeconds();

      const apiUrl = `/api/invoice_dump?startDate=${sDate}&endDate=${eDate}`;
      try {
        const response = await axios.get(apiUrl, {
          responseType: "blob", // This indicates that the response is a binary blob
        });

        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `invoice-report-${showTime}.xlsx`;
        link.click();
      } catch (error) {
        console.error("Error downloading Excel:", error);
      }
    }
  };

  function add3Dots(string, limit) {
    var dots = "...";
    if (string.length > limit) {
      // you can also use substr instead of substring
      string = string.substring(0, limit) + dots;
    }

    return string;
  }


  //pagination
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      . Showing {from} to {to} of {size} Results"
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "10",
        value: 10,
      },
      {
        text: "All",
        value: categorylist.length,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
  };
  var add = add3Dots("address", 25);
  const ans = add3Dots("address", 25);

  //columns of table
  const columns = [
    {
      dataField: "id",
      text: "ID",
      headerStyle: (colum, colIndex) => {
        return { width: '40px', textAlign: 'center' };
      }
    },
    
    {
      dataField: "invoice_no",
      text: "Invoice No",
      filter: textFilter(),
      headerStyle: (colum, colIndex) => {
        return { width: '200px'};
      }
    },
    
    {
      dataField: "customer_party_name",
      text: "Billing Party Name",
      filter: textFilter(),
      // style: {overflow : Hidden }
    },
    {
      dataField: "customer_party_code",
      text: "Billing Party Code",
      filter: textFilter(),
      headerStyle: (colum, colIndex) => {
        return { width: '100px', textAlign: 'center' };
      }
      // style: {overflow : Hidden }
    },
    {
      dataField: "invoice_date",
      text: "Invoice Date",
      filter: textFilter(),
      headerStyle: (colum, colIndex) => {
        return { width: '130px', textAlign: 'center' };
      }
      // style: {overflow : Hidden }
    },
    {
      dataField: "sub_total",
      text: "Sub Total",
      headerStyle: (colum, colIndex) => {
        return { width: '130px', textAlign: 'center' };
      }
    },
    {
        dataField: "gst_total",
        text: "GST Total",
        headerStyle: (colum, colIndex) => {
          return { width: '130px', textAlign: 'center' };
        }
      },
      {
        dataField: "total_amount",
        text: "Total Amount",
        headerStyle: (colum, colIndex) => {
          return { width: '130px', textAlign: 'center' };
        }
      },
    {
      dataField: 'action',
      text: 'Actions',
      headerStyle: (colum, colIndex) => {
        return { width: '150px' };
      },
      // style: {textAlign:'center' },
      formatter:  (cell, row, rowIndex, formatExtraData) => { 
        // console.log(row);
        const customerId = row.id;
        // console.log(customerId);


        return (
          <ThemeProvider theme={theme}>
          <Grid container spacing={2}>
          <Grid item xs={3}>

           
           <a
              style={{ color: "white", textDecoration: "none" }}
              href={"https://cert.geekay.biz/backend/api/bill/" + customerId}
              // href={"/api/bill/" + customerId}
              target="_blank"
              rel="noreferrer"
            >
            <Button color="apple" size="medium" startIcon={<DownloadIcon color='inherit'/>}/>
            </a>
           {/* </Button> */}
          </Grid>


           <Grid item xs={3}>
           <Button component={Link} to={`/certificates/update_invoice/${customerId}`} color="apple" size="medium" startIcon={<EditIcon color='inherit'/>}/>
          {/* <td><Link to={`edit-customer/${item.id}`} className="btn btn-success btn-sm">Edit</Link></td> */}
          {/* <td><button type="button" onClick={(e) => deleteUser(e, item.id)} className="btn btn-danger bt-sm">Delete</button></td> */}
          </Grid>
          <Grid item xs={3}>
          {/* <Button onClick={(e) => deleteUser(e, customerId )}  color="error" size="medium" startIcon={<DeleteIcon color='warning'/>}/> */}
          </Grid>
           </Grid>
           </ThemeProvider>
        )
      },
    },
  ];
  const [sDate, setsDate] = useState('');
  const [eDate, seteDate] = useState('');
  // const handleInput = (e) => {
  //   e.persist();
  //   setReportInput({ ...reportInput, [e.target.name]: e.target.value });
  // };
  const handlesdateChange = (e) => {
    setsDate(e.target.value);
  };

  const handleedateChange = (e) => {
    seteDate(e.target.value);
  };

  const [list, setlist] = useState([]);
  const submitBillData = (e) => {
    e.preventDefault();
    // console.log(month,"ALI");
    // console.log(year,"ALI");
    const apiUrl = `/api/view-invoices?startDate=${sDate}&endDate=${eDate}`;

    axios.get(apiUrl).then((res) => {
      if (res.data.status === 200) {
        // console.log(res.data.idlr);
        setlist(res.data.bill);
        // setlist(res.data.industrial);
        // console.log(res.data.industrial);
      } else if (res.data.status === 400) {
        // setbillInput({ ...setbillInput, error_list: res.data.errors });
      }
    });
  };

  return (
    <div>
    <Navbar />
    <div className="row" style={{ marginTop: 20, width: "97%" }}>
      <div className="col-sm-12" style={{ marginLeft: 40 }}>
        <div className="card">
          <div className="card-header row">
            <div className="col-sm-11">
              <h4>
                <b>Invoices</b>
              </h4>
            </div>
            <div
                className="col-sm-1"
                style={{ textAlign: 'right' }}
              >
                <ThemeProvider theme={theme}>
                  <Button
                    color="apple"
                    size="medium"
                    onClick={dumpInvoiceData}
                    startIcon={<DownloadIcon color="inherit" />}
                  ></Button>
                </ThemeProvider>
              </div>
          </div>
          <form onSubmit={submitBillData} id="REPORT_FORM">
            <div className="card-body">
              <div className="row">
                <div className="col-sm-2" style={{ marginBottom: "15px" }}>
                <label>Start Date</label>
                    <input type="date" value={sDate} onChange={handlesdateChange} id="startDate" className="form-control" name="startDate"></input>
                </div>
                <div className="col-sm-2" style={{ marginBottom: "15px" }}>
                <label>End Date</label>
                    <input type="date" value={eDate} onChange={handleedateChange} id="endDate" className="form-control" name="endDate"></input>
                </div>
                <div className="col-sm-2" style={{ marginBottom: "15px" }}>
                  <ThemeProvider theme={theme}>
                    <Box
                      //  marginTop={}
                      display="flex"
                      padding={3}
                      borderRadius={5}
                      alignItems="center"
                      justifyContent={"center"}
                    >
                      {/*<ThemeProvider theme={theme}>*/}
                      <Button
                        style={{
                          maxWidth: "200px",
                          maxHeight: "100px",
                          minWidth: "50px",
                          minHeight: "30px",
                        }}
                        color="apple"
                        type="submit"
                        variant="contained"
                      >
                        Submit
                      </Button>
                    </Box>
                  </ThemeProvider>
                </div>
                
              </div>
            </div>
          </form>
        </div>
                        
    <BootstrapTable keyField='id' data={list} columns={columns} hover condensed
        // pagination={paginationFactory(options)}
        filter={filterFactory()}
        
      />
        </div>
      </div>
    </div>
//   </div>
    
  )
}

export default ShowInvoices
